import { Fragment } from "react";
import { useTexts } from "../../hooks";
import SelectModal from "./SelectModal";
import { useAppSelector } from "../../hooks";
import { RootState } from "../../store";
import Help from "./Help";
import Paytable from "./Paytable";
import Error from "./Error";
import Message from "./Message";
import FreeRounds from "./FreeRounds";
import FreeRoundsEnd from "./FreeRoundsEnd";
import HistoryModal from "./History";
import RealityCheck from "./RealityCheck";
import StakeSelect from "./StakeSelect";
import AutoplaySelect from "./AutoplaySelect";
import Commander from "../../commander";
import BuyBonus from "./BuyBonus";
import SelectBuyBonus from "./BuyBonus/SelectBuyBonus";
import PreviousWin from "./PreviousWin";

const Modals: React.FC = () => {
  const { info, modals, error, messages, loadingScreen } = useAppSelector(
    (state: RootState) => {
      return {
        info: state.selectors.info,
        modals: state.modals,
        error: state.error || { code: 0, title: "", message: "" },
        messages: state.messages,
        loadingScreen: state.loadingScreen,
      };
    }
  );

  const { common } = useTexts();
  const infoData = {
    ...info,
    possibleValues: info.possibleValues.map(
      ({ value, text }: { value: string | number; text: string }) => {
        // the "text" is actually the key for the translations
        return { text: common[text] ?? "undefined", value };
      }
    ),
  } as any;

  return (
    <Fragment>
      <StakeSelect shown={modals.active === "stake"} />
      <AutoplaySelect shown={modals.active === "autoplay"} />
      <SelectModal
        transitional={true}
        data={infoData}
        shown={modals.active === "info"}
        soundEffect="button-click"
        onSelect={(value) => Commander.openModal(value, 320)}
      />
      <Help shown={modals.active === "help"} />
      <Paytable shown={modals.active === "pays"} />
      <HistoryModal shown={modals.active === "history"} />
      <RealityCheck shown={modals.active === "realityCheck"} />
      <Error
        shown={modals.active === "error"}
        code={error.code}
        title={error.title}
        data={error.data}
        message={error.message}
      />
      <Message
        shown={modals.active === "message" && !loadingScreen.visible}
        title={messages.title}
        message={messages.message}
        amount={messages.amount}
        timer={messages.timer}
        placeholderValues={messages.placeholderValues}
      />
      <FreeRounds shown={modals.active === "freeRounds"} />
      <FreeRoundsEnd shown={modals.active === "freeRoundsEnd"} />
      <BuyBonus shown={modals.active === "buyBonus"} />
      <SelectBuyBonus shown={modals.active === "selectBuyBonus"} />
      <PreviousWin shown={modals.active === "previousWin"} />
    </Fragment>
  );
};

export default Modals;
